/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandColorRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandColorResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandColor = (request: SetBrandColorRequest, options?: CashRequestOptions) => post<SetBrandColorRequest, SetBrandColorResponse>("/2.0/cash/set-brand-color", request, {...options, rejectOnError: true })